import bTable from './table.vue';

export default bTable;


//////////////////
// WEBPACK FOOTER
// ./node_modules/bootstrap-vue/es/components/table/table.js
// module id = null
// module chunks = 